<div class="ticket-preview">
    <div class="ticket-meta">
        <h2 class="ticket-title">{{ raceShortNameFormat }}</h2>
        <h3 class="ticket-subtitle"></h3>
        <button class="btn-close" (click)="onCloseDialog()"></button>
    </div>
    <div class="ticket-content">
        <div class="ticket-lines print-zone" id="ticketArea">
            @for (line of ticketData; track $index) {
                <pre>{{line}}</pre>
            }
        </div>
        @if (ticketActions.length) {
            <div class="ticket-actions">
                @for (btn of ticketActions; track $index) {
                    <button class="btn {{btn.className}}" (click)="btn.action()">{{btn.label | translate}}</button>
                }
            </div>
        }
    </div>

</div>
